var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioBooksIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 78V66.9045C130 38.0315 107.386 13.858 79.5925 13.0195C65.2665 12.688 51.961 17.8035 41.7885 27.6835C36.7733 32.5151 32.7888 38.3125 30.0753 44.726C27.3618 51.1395 25.9755 58.0362 26 65V78C18.8305 78 13 83.8305 13 91V117C13 124.17 18.8305 130 26 130H39V65C38.9808 59.7772 40.0197 54.6047 42.054 49.7943C44.0883 44.9839 47.0759 40.6354 50.8365 37.011C54.5813 33.3657 59.023 30.5134 63.8959 28.6247C68.7688 26.7361 73.9727 25.85 79.196 26.0195C100.048 26.6435 117 44.9865 117 66.9045V130H130C137.17 130 143 124.17 143 117V91C143 83.8305 137.17 78 130 78Z",
    fill: "#0066FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 78H58.5V130H45.5V78ZM97.5 78H110.5V130H97.5V78Z",
    fill: "#0066FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioBooksIcon);
export default __webpack_public_path__ + "static/media/audio_books_icon.53a26566.svg";
export { ForwardRef as ReactComponent };